import React, { useState } from 'react';
import { BiArrowFromLeft, BiArrowFromRight } from 'react-icons/bi';
import { VscCloudUpload } from 'react-icons/vsc';
import { useDispatch } from 'react-redux';
import AccesRestreins from '../../hoc/AccesRestreins/AccesRestreins';
import { checkMot } from '../../ressources/functionJS/checkMot';
import * as conteneurInfo from '../../ressources/glossaires/glossaire_conteneur_info';
import * as privilege from '../../ressources/glossaires/glossaire_privileges';
import * as type_btn from '../../ressources/glossaires/glossaire_type_de_bouton';
import * as actions from '../../services/actions';
import ProfilCapteur from '../Capteur/ProfilCapteur/ProfilCapteur';
import ConteneurInformation from '../ConteneurInformation/ConteneurInformation';
import Bouton from '../UI/Bouton/Bouton';
import AjouterCapteur from './Ajouter/AjouterCapteur';
import S from './Capteur.module.scss';
import ImporterCapteurCSV from './ImporterCapteurCSV/ImporterCapteurCSV';
import TableauCapteur from './TableauCapteur/TableauCapteur';

const Capteur = () => {
  const dispatch = useDispatch();

  // Split state into multiple useState hooks
  const [parametresSelectione, setParametresSelectione] = useState({});
  const [montrerInfo, setMontrerInfo] = useState(false);
  const [indexConteneurInfo, setIndexConteneurInfo] = useState(null);
  const [montrerInfoFull, setMontrerInfoFull] = useState(false);

  // Event handlers
  const capteurSelectione = (info) => {
    setParametresSelectione(info);
    setIndexConteneurInfo(conteneurInfo.profil);
    setMontrerInfo(true);
  };

  const commutateurInfoCreer = () => {
    setMontrerInfo((prevMontrerInfo) => {
      if (prevMontrerInfo) {
        setMontrerInfoFull(false);
      }
      return !prevMontrerInfo;
    });
  };

  const commutateurInfoFull = () => {
    setMontrerInfoFull((prev) => !prev);
  };

  const commutateurAnnuler = (event) => {
    event.preventDefault();
    setMontrerInfo(false);
    setIndexConteneurInfo(null);
  };

  const creerCapteur = () => {
    setMontrerInfo(true);
    setIndexConteneurInfo(conteneurInfo.ajouterForm);
  };

  const handleImportClick = () => {
    setMontrerInfo(true);
    setIndexConteneurInfo(conteneurInfo.importation);
  };

  // Action handlers
  const ajouterAlerte = (typeAlerte, titre, corps) => {
    dispatch(actions.ajouterAlerte(typeAlerte, titre, corps));
  };

  const reqAjouter = (formulaireCreerCapteur) => {
    dispatch(actions.reqAjouterCapteur(formulaireCreerCapteur));
  };

  const reqModifier = (formulaireModifierCapteur) => {
    dispatch(actions.reqModifierCapteur(formulaireModifierCapteur));
  };

  const reqSupprimer = (idCapteur) => {
    dispatch(actions.reqSupprimerCapteur(idCapteur));
  };

  const reqImportationCapteursEnLot = (idCapteur) => {
    dispatch(actions.reqImportationCapteursEnLot(idCapteur));
  };

  // Compute styles
  const styleConteneurCentralGauche = [S.ConteneurCentralGauche];
  const styleConteneurCentralDroite = [S.ConteneurCentralDroite];
  const commutateurClasses = [S.CommutateurInfo];

  if (montrerInfo && montrerInfoFull) {
    styleConteneurCentralDroite.push(S.ConteneurCentralDroiteFull);
    styleConteneurCentralGauche.push(S.ConteneurCentraGaucheVoid);
  } else if (montrerInfo && !montrerInfoFull) {
    styleConteneurCentralDroite.push(S.ConteneurCentralDroiteOuvert);
  } else {
    styleConteneurCentralDroite.push(S.ConteneurCentralDroiteFermer);
    styleConteneurCentralGauche.push(S.ConteneurCentraGaucheFermer);
  }

  return (
    <div className={[S.ConteneurUtilisateur].join(' ')}>
      <div className={styleConteneurCentralGauche.join(' ')}>
        <TableauCapteur
          selectioneLigne={capteurSelectione}
          creer={creerCapteur}
        >
          <div className={S.titleModule}> {checkMot('capteurs')} </div>
          <AccesRestreins numPrivilege={privilege.modifier_des_capteurs}>
            <Bouton
              hoverText={checkMot('upload')}
              type={type_btn.outil}
              rond={true}
              cliquer={handleImportClick}
            >
              <VscCloudUpload size={15} />
            </Bouton>
          </AccesRestreins>
        </TableauCapteur>
      </div>
      <div
        className={`${styleConteneurCentralDroite.join(' ')} ${S.separation}`}
      >
        <Bouton
          ajoutClass={[commutateurClasses, S.expandTO].join(' ')}
          rond={true}
          type={type_btn.danger}
          cliquer={commutateurInfoCreer}
        >
          <BiArrowFromLeft size={15} />
        </Bouton>
        <Bouton
          ajoutClass={S.expand}
          cliquer={commutateurInfoFull}
          rond={true}
          type={type_btn.danger}
        >
          <BiArrowFromRight size={15} />
        </Bouton>

        <ConteneurInformation
          selectionInfo={indexConteneurInfo}
          ajouterForm={
            <AjouterCapteur
              ajouterAlerte={ajouterAlerte}
              annuler={commutateurAnnuler}
              ajouter={reqAjouter}
            />
          }
          profil={
            <ProfilCapteur
              infoCapteur={parametresSelectione}
              reqModifier={reqModifier}
              reqSupprimer={reqSupprimer}
              ajouter={reqAjouter}
            />
          }
          importation={
            <ImporterCapteurCSV
              reqAjouter={reqAjouter}
              reqModifier={reqModifier}
              reqImportationCapteursEnLot={reqImportationCapteursEnLot}
            />
          }
        />
      </div>
    </div>
  );
};

export default Capteur;
